import React from "react";
import RenderSlate from "@whalecloud/page-builder-core/components/Slate";
import { ElementRoot } from "@whalecloud/page-builder-core/components/ElementRoot";
import { PbElement } from "@whalecloud/page-builder-core/utils/types";

const Text = ({ element }: { element: PbElement }) => {
    const { componentSettings, className: textClassName } = element?.data;
    return (
        <ElementRoot element={element} className={`${className} ${textClassName}`} style={{ ...componentSettings }}>
            <RenderSlate value={element.data.text} disableEditing={true} toolbarDisable={true} />
        </ElementRoot>
    );
};

export const className = "webiny-pb-base-page-element-style webiny-pb-page-element-text";

export default Text;
